import createAxios from "./axiosHttp";

function getEvidenceById(evidenceId) {
  const axios = createAxios();
  const urlPath = `ttmm/evidence/${evidenceId}`;
  return axios.get(urlPath);
}

function getEvidences(pagination, query, sort) {
  const axios = createAxios();
  const urlPath = "ttmm/evidence/ql";
  return axios.post(urlPath, { pagination, query, sort });
}

export const evidenceService = {
  getEvidenceById,
  getEvidences,
};
